import * as React from 'react';

import CampaignAchievementsStatsCard from './CampaignAchievementsStatsCard';

import { __t, applyTranslations } from 'utils/language';

import type { CampaignAchievementMetric } from 'types';

applyTranslations(require('./campaign-achievements-stats.i18n.json'));

type Props = {
  stats: Array<CampaignAchievementMetric>
};

const CampaignAchievementsStats = (
  {
    stats
  }: Props
): JSX.Element => (
  <section className="campaign-achievements-stats">
    <h2 className="campaign-achievements-stats__title">
      {__t('campaign_achievements_stats.title')}
    </h2>
    <section className="campaign-achievements-stats-items">
      {
        stats.map((stat) => (
          <CampaignAchievementsStatsCard
            key={`campaign-achievement-stats-${stat.id}`}
            // $FlowIgnore - Cannot determine a type for props [1]. CampaignAchievementMetric [2] is inexact
            {...stat}
          />
        ))
      }
    </section>
  </section>
);

export default CampaignAchievementsStats;
